__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-10-19-1792406822-stable-dev/";